import script from "./durationFilter.vue?vue&type=script&setup=true&lang=ts"
export * from "./durationFilter.vue?vue&type=script&setup=true&lang=ts"

import "./durationFilter.vue?vue&type=style&index=0&id=08fcd2ce&scoped=true&lang=scss"

import exportComponent from "c:\\jenkins\\workspace\\Client_Windows_build\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08fcd2ce"]])

export default __exports__